(function () {
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lr-qty]');
    if (q) {
      var input = q.parentElement.querySelector('input[name="quantity"]');
      var n = Math.max(1, Math.min(10, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.lrQty, 10)));
      input.value = n;
      return;
    }
    // Buy it now: checkout with ONLY this item (cart permalink), ignoring anything already in the cart
    var bn = e.target.closest('[data-lr-buynow]');
    if (bn) {
      e.preventDefault();
      var f = bn.form;
      var id = f.querySelector('input[name="id"]').value;
      var qi = f.querySelector('input[name="quantity"]');
      var qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
      window.location.href = '/cart/' + id + ':' + qty;
      return;
    }
    var t = e.target.closest('[data-lr-thumb]');
    if (t) {
      var g = t.closest('[data-lr-gallery]');
      var main = g.querySelector('.lr-gallery__main img');
      main.removeAttribute('sizes');
      main.src = t.dataset.src;
      main.srcset = t.dataset.srcset || '';
      main.alt = t.dataset.alt || '';
      g.querySelectorAll('[data-lr-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    }
  });
})();
